
export default {
  name: "CouponEmpty",
  data() {
    return {}
  },
  methods: {}
}
